import {
  ApolloLink,
  FieldPolicy,
  FieldReadFunction,
  TypePolicy,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { createAuthorizationHeaderValue } from './auth';

type KeySpecifierOf<TFieldName extends string> = readonly (
  | TFieldName
  | readonly (string | readonly string[])[]
)[];

type TypePolicyOf<TType> = Omit<TypePolicy, 'fields' | 'keyFields'> & {
  keyFields?: false | KeySpecifierOf<Extract<keyof TType, string>>;
  fields?: {
    [TFieldName in keyof TType]?: FieldPolicy | FieldReadFunction;
  };
};

/**
 * Apollo type policies checked against the generated schema types. Apollo's
 * own type accepts any typename and field, so a typo or a renamed field
 * becomes a policy that silently never applies; this turns that into a
 * compile error. The root query is keyed as `Query`, Apollo's default.
 */
export type TypedTypePolicies<
  TType extends { __typename?: string },
  TRootQuery,
> = {
  [TEntry in TType as NonNullable<TEntry['__typename']>]?: TypePolicyOf<TEntry>;
} & { Query?: TypePolicyOf<TRootQuery> };

/** Creates the Auth link for Apollo. */
export function createAuthLink(): ApolloLink {
  return setContext(async (_, { headers }) => {
    const authorization = await createAuthorizationHeaderValue();
    return {
      headers: {
        ...headers,
        authorization,
      },
    };
  });
}
